<template>
<box-view title="Quản lí tài khoản" class="account" @close="$router.back()">
    <div class="container py-3">

    <!-- Avatar -->
    <div class="text-center mb-4">
        <div class="avatar-wrapper" @click="chooseAvatar">
        <img :src="localUser.avatar" class="avatar-img" />
        <div class="avatar-mask">
            <i class="fas fa-camera"></i>
        </div>
        </div>

        <input
        ref="fileInput"
        type="file"
        accept="image/*"
        hidden
        @change="onAvatarChange"
        />

        <div class="small text-muted mt-2">
        Nhấn để đổi ảnh đại diện
        </div>
    </div>

    <!-- Thông tin -->
    <van-field
        v-model="localUser.name"
        label="Họ tên"
        placeholder="Nhập họ tên"
    />

    <van-field
        v-model="localUser.phone"
        label="Số điện thoại"
        disabled
    />

    <van-field
        v-model="localUser.role"
        label="Vai trò"
        disabled
    />

    <div class="mt-3">
        <van-button block type="primary" @click="saveProfile">
        Lưu thông tin
        </van-button>
    </div>

    <!-- Đổi mật khẩu -->
    <div class="mt-4">
        <h6 class="fw-bold mb-2">Đổi mật khẩu</h6>

        <van-field
        v-model="password.old"
        type="password"
        label="Mật khẩu cũ"
        placeholder="Nhập mật khẩu cũ"
        />

        <van-field
        v-model="password.new"
        type="password"
        label="Mật khẩu mới"
        placeholder="Nhập mật khẩu mới"
        />

        <van-field
        v-model="password.confirm"
        type="password"
        label="Xác nhận"
        placeholder="Nhập lại mật khẩu"
        />

        <van-button
        block
        type="warning"
        class="mt-2"
        @click="changePassword"
        >
        Đổi mật khẩu
        </van-button>
    </div> 

    </div>

</box-view>
</template>
<script>
export default {
    props: {
        user: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
    return {
        localUser: { ...this.user },
        password: {
            old: '',
            new: '',
            confirm: ''
        }
    };
    },
    watch: {
        user: {
            handler(val) {
                this.localUser = { ...val };
            },
            deep: true
        }
    },
    methods: {
    chooseAvatar() {
        this.$refs.fileInput.click();
    },

    onAvatarChange(e) {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('avatar', file);

        this.$root.api.post('logach/user/upload-avatar', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            if (res.data.status === 'OK') {
                this.localUser.avatar = res.data.url;
                this.$toast?.('Đã tải ảnh lên');
            } else {
                this.$toast?.fail(res.data.error);
            }
        }).catch(err => this.$root.showError(err));
    },

    saveProfile() {
        this.$root.api.post('logach/user/update-profile', {
            full_name: this.localUser.name,
            avatar: this.localUser.avatar
        }).then(res => {
            if (res.data.status === 'OK') {
                this.$root.auth = res.data.auth;
                this.$emit('update-user', res.data.auth);
                this.$toast?.('Cập nhật thành công');
            } else {
                this.$toast?.fail(res.data.error);
            }
        }).catch(err => this.$root.showError(err));
    },

    changePassword() {
        if (!this.password.old || !this.password.new) {
            this.$toast?.('Vui lòng nhập đầy đủ');
            return;
        }
        if (this.password.new !== this.password.confirm) {
            this.$toast?.('Mật khẩu không khớp');
            return;
        }

        this.$root.api.post('logach/user/change-password', {
            old_password: this.password.old,
            new_password: this.password.new
        }).then(res => {
            if (res.data.status === 'OK') {
                this.$toast?.('Đổi mật khẩu thành công');
                this.password = { old: '', new: '', confirm: '' };
            } else {
                this.$toast?.fail(res.data.error);
            }
        }).catch(err => this.$root.showError(err));
    },
    close() {
        this.$router.back();
    },
    }
};
</script>